export default __webpack_public_path__ + "assets/0dc17b.svg";